<div fxFlex="100" class="wrapper-dashboard">

  <!-- Main Content -->
  <div *ngIf="(data.length || filtersApplied || dataLoader) else noDataTemplate" fxLayout="row">
    <!-- Loading Spinner -->
    <div *ngIf="dataLoader" class="data-spinner">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <!-- Card-Based Patient List -->
    <div *ngIf="!dataLoader" class="patient-list" fxFlex="96%" fxFlex.xs="100%">

      <!-- Controls Row: Update on left, Filter Ward + Close All on right -->
      <div class="controls-row">
        <!-- Left: Refresh button + last check timestamp -->
        <div class="update-section">
          <button (click)="RefreshData()" class="lenexa-btnn">{{ 'Update' | translate }}</button>
          <p>{{ 'Last Check' | translate }}: {{updatedTime}}</p>
        </div>

        <!-- Right: Ward filter + Close All Timelines -->
        <div class="filter-close-section">
          <div class="filter-section">
            <span class="filter-label">{{ 'Filter by Ward' | translate }}</span>

            <!-- Ward Filter Dropdown -->
            <div class="ward-filter-dropdown">
              <button
                class="ward-filter-button"
                [class.active]="isWardFilterOpen"
                (click)="toggleWardFilter()">
                {{ selectedWard || 'All Wards' | translate }}
              </button>

              <!-- Ward Filter Dropdown Menu -->
              <div class="drop-toggle" *ngIf="isWardFilterOpen">
                <div class="filter-options">
                  <p>{{ 'Select Ward' | translate }}</p>
                  <hr />
                  <label>
                    <input
                      type="radio"
                      name="ward"
                      [checked]="!selectedWard"
                      (change)="filterByWard(null)">
                    {{ 'All Wards' | translate }}
                  </label>
                  <label *ngFor="let ward of availableWards">
                    <input
                      type="radio"
                      name="ward"
                      [checked]="selectedWard === ward"
                      (change)="filterByWard(ward)">
                    {{ ward }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <button class="closeall" (click)="closeAllgraphs()">
            {{ 'Close All Timelines' | translate }}
          </button>
        </div>
      </div>

      <!-- Header Row (Table-like headers) -->
      <div class="dashboard-header-row" *ngIf="data.length && !dataLoader">
        <div class="header-col">{{ 'Hub ID' | translate }}</div>
        <div class="header-col">{{ 'Data Status' | translate }}</div>
        <div class="header-col">{{ 'Ward' | translate }}</div>
        <div class="header-col">{{ 'Bed' | translate }}</div>
        <div class="header-col">{{ 'Risk Status' | translate }}</div>
      </div>

      <!-- Patient Cards -->
       <div class="patient-card-container">
        <div *ngFor="let item of data; let i=index" 
            class="patient-card"
            [class.expanded]="item.isSelected"
            [ngClass]="{
              'critical': item.risk_type === 'High Risk',
              'warning': item.risk_type === 'Mid Risk',
              'safe': item.risk_type === 'No Risk' || item.risk_type === 'Safe',
              'neutral': item.risk_type === 'Out Of Bed',
              'no-data': item.risk_type === 'No Data'
            }"
            (click)="toggleCardTimeline(item, $event)">
          
          <span class="card-click-hint">
            {{ item.isSelected ? ('Click to collapse' | translate) : ('Click to expand' | translate) }}
          </span>
          
          <div class="card-header">
            <div class="card-info-grid">
              <div class="card-field">
                <div class="card-label">{{ 'Hub ID' | translate }}</div>
                <div class="card-value">{{item.hub_id}}</div>
              </div>
              
              <div class="card-field">
                <div class="card-label">{{ 'Data Status' | translate }}</div>
                <div class="data-status-indicator">{{item.datastatus | translate}}</div>
              </div>
              
              <div class="card-field">
                <div class="card-label">{{ 'Ward' | translate }}</div>
                <div class="card-value">{{item.ward}}</div>
              </div>
              
              <div class="card-field">
                <div class="card-label">{{ 'Bed' | translate }}</div>
                <div class="card-value">{{item.bed}}</div>
              </div>
            </div>

            <div class="status-badge"
                [ngClass]="{
                  'critical': item.risk_type === 'High Risk',
                  'warning': item.risk_type === 'Mid Risk',
                  'safe': item.risk_type === 'No Risk' || item.risk_type === 'Safe',
                  'neutral': item.risk_type === 'Out Of Bed' || item.risk_type === 'No Data'
                }">
              <span class="status-text">{{ translateRiskStatus(item.risk_status) }}</span>
              
              <!-- Seek Help Button for No Data -->
              <button class="seek-help-btn" *ngIf="item.risk_type === 'No Data'" (click)="seekHelp($event, item)">
                <mat-icon>report_problem</mat-icon>
                <span class="seek-help-text">{{ 'Seek Help' | translate }}</span>
              </button>
            </div>
          </div>

          <div class="card-timeline" *ngIf="item.isSelected" (click)="$event.stopPropagation()">
            <app-timeline 
              [timelineId]="item.patient_number" 
              [dataToDisplay]="item.timelineGraphData"
              [graphId]="item.timeGraphId">
            </app-timeline>
          </div>
        </div>
      </div>
            



      <!-- Pagination -->
      <div fxLayout="row" class="page-count">
        <div class="page-container">
          {{ 'Page' | translate }}:
          <span *ngFor="let page of pagesArray; let last = last" 
                (click)="goToPage(page)"
                [class.active]="currentPage === page">
            {{ page }}{{ last ? '' : ',' }}
          </span>
        </div>
        <img class="pagecontainer-arrows"
          src="assets/images/Polygon 4.png" 
          (click)="previousPage()"
          [style.opacity]="currentPage === 1 ? 0.3 : 1" 
          [attr.disabled]="currentPage === 1 ? true : null" />
        <img class="pagecontainer-arrows"
          src="assets/images/Polygon 3.png" 
          (click)="nextPage()"
          [style.opacity]="currentPage === totalPages ? 0.3 : 1"
          [attr.disabled]="currentPage === totalPages ? true : null" />
      </div>
    </div>
  </div>
</div>

<!-- No Data Template -->
<ng-template #noDataTemplate>
  <div class="display-center">
    <h3>{{ 'No active bed, please click the "Add device" button to add a bed.' | translate }}</h3>
  </div>
</ng-template>

<!-- 
  FILTERS OVERLAY (Data Status & Risk Status filters)
  Position: absolute, shown when filter icons clicked
-->
<div class="filter-overlays" *ngIf="isDropdownOpen">
  <!-- Data Status Filter -->
  <div class="drop-toggle" *ngIf="activeDropdown === 'datastatus'" 
       style="position: fixed; top: 200px; right: 50px; z-index: 10000;">
    <div class="filter-options">
      <p>{{ 'Data Status Filter' | translate }}</p>
      <hr />
      <label *ngFor="let item of dataStatus">
        <input type="checkbox" 
               [(ngModel)]="item.selected"
               (change)="handleCheckboxSelection('datastatus', item)"> 
        {{ item.name | translate }}
      </label>
    </div>
    <div class="filter-btns">
      <button class="submit-btn"
              (click)="filterData('datastatus','selectedDataStatusCheckboxes')">
        {{ 'Confirm' | translate }}
      </button>
      <button (click)="closeFilter()" class="cancel-btn">
        {{ 'Cancel' | translate }}
      </button>
    </div>
  </div>

  <!-- Risk Status Filter -->
  <div class="drop-toggle1" *ngIf="activeDropdown === 'riskstatus'"
       style="position: fixed; top: 200px; right: 50px; z-index: 10000;">
    <div class="filter-options1">
      <p>{{ 'Risk Status Filter' | translate }}</p>
      <hr />
      <label *ngFor="let item of riskStatus">
        <input type="checkbox" 
               [(ngModel)]="item.selected"
               (change)="handleCheckboxSelection('risk_type', item)"> 
        {{ item.name | translate }}
      </label>
    </div>
    <div class="filter-btns1">
      <button class="submit-btn1"
              (click)="filterData('risk_type','selectedRiskStatusCheckboxes')">
        {{ 'Confirm' | translate }}
      </button>
      <button (click)="closeFilter()" class="cancel-btn1">
        {{ 'Cancel' | translate }}
      </button>
    </div>
  </div>
</div>